/*
 * @Author: 陈祖康
 * @Date: 2021-03-26 14:45:04
 * @LastEditors: 陈祖康
 * @LastEditTime: 2021-03-26 16:11:44
 * @Description: 入口文件
 * @Props: 
 * @Emit: 
 */
import * as env from './util-tool/env'; // 方法集合1
import * as is from './util-tool/is'; // 方法集合2
import { Types } from './types/index';
import { mixin } from './tools/index';

function initUtils(): Types {
  const instance = Object.create(null)
  const arr = [env, is];
  mixin(instance, arr)
  return instance as Types
}

const _utils = initUtils()

export default _utils